/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { STORE_BANK_AND_TAX_STATUS, BankAndTaxStatusAction, UPDATE_BANK_AND_TAX_STATUS, UpdateBankAndTaxStatusAction } from "../actions/actions";
import { PaymentAndTaxStatus } from "../../models/model";

export function bankAndTaxStatuses(
    state: PaymentAndTaxStatus[] = [],
    action: BankAndTaxStatusAction & UpdateBankAndTaxStatusAction
): PaymentAndTaxStatus[] {
    switch (action.type) {
        case STORE_BANK_AND_TAX_STATUS: {
            return action.payload;
        }
        case UPDATE_BANK_AND_TAX_STATUS: {
            return[
                ...state.filter(b => b.offeringId != action.payload.offeringId),
                action.payload as PaymentAndTaxStatus
            ]
        }
        default:
            return state;
    }
}
